import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const BlogRootEntityTypes = [
  EntityTypeEnum.BlogPageBody,
  EntityTypeEnum.BlogPostLayoutBody,
  EntityTypeEnum.BlogPostBody,
  structureTypes.BLOG_PAGE_BODY,
  structureTypes.BLOG_POST_BODY,
  structureTypes.BLOG_POST_LAYOUT_BODY,
]
